import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { ReactElement, useCallback } from 'react';
import * as yup from 'yup';
import PmiTextField from 'shell/components/shared/text-field';

export interface StampCertificateForm {
  // title?: string;
  editor?: string;
  text?: string;
  type?: string;
  printElement?: string;
  typeAct?: string;
  code?: string;
}

const validationSchema = yup.object({
  text: yup.string().required('Il campo è obbligatorio'),
  // title: yup.string().required('Il campo è obbligatorio'),
  type: yup.string().required('Il campo è obbligatorio'),
  printElement: yup.string().required('Il campo è obbligatorio'),
  code: yup.string().required('Il campo è obbligatorio'),
  typeAct: yup.string().required('Il campo è obbligatorio'),
});

interface FormStampCertificateProps {
  onOk: (form: StampCertificateForm) => void;
  onCancel: (form?: StampCertificateForm) => void;
  title: string;
  children?: ReactElement;
  disabled?: boolean;
  isEdit?: boolean;
  initialValues?: StampCertificateForm;
}

const FormStampCertificate = ({
  onOk,
  onCancel,
  title,
  disabled = false,
  initialValues,
}: FormStampCertificateProps): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const formStampCertificate = useFormik<StampCertificateForm>({
    initialValues: initialValues || {
      // title: '',
      code: '',
      typeAct: '',
      printElement: '',
      text: '',
      type: '',
      editor: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
    validateOnMount: true,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={formStampCertificate.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              {/* <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Titolo"
                  label="Titolo *"
                  id="title"
                  name="title"
                  type="text"
                  inputProps={{
                    maxLength: '50',
                  }}
                  variant="outlined"
                  value={formStampCertificate.values.title || ''}
                  disabled={disabled}
                  fullWidth
                  onChange={formStampCertificate.handleChange}
                  error={
                    formStampCertificate.touched.title && Boolean(formStampCertificate.errors.title)
                  }
                  helperText={formStampCertificate.errors.title}
                />
              </Grid> */}
              <Grid item xs={12} md={3}>
                <PmiTextField
                  aria-label="Codice"
                  label="Codice *"
                  id="code"
                  name="code"
                  type="text"
                  inputProps={{
                    maxLength: '3',
                  }}
                  variant="outlined"
                  value={formStampCertificate.values.code || ''}
                  disabled={disabled}
                  fullWidth
                  onChange={formStampCertificate.handleChange}
                  error={
                    formStampCertificate.touched.code && Boolean(formStampCertificate.errors.code)
                  }
                  helperText={formStampCertificate.errors.code}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Tipo di stampa"
                  label="Tipo di stampa*"
                  id="type"
                  name="type"
                  type="text"
                  inputProps={{
                    maxLength: '50',
                  }}
                  variant="outlined"
                  value={formStampCertificate.values.type || ''}
                  disabled={disabled}
                  fullWidth
                  onChange={formStampCertificate.handleChange}
                  error={
                    formStampCertificate.touched.type && Boolean(formStampCertificate.errors.type)
                  }
                  helperText={formStampCertificate.errors.type}
                />
              </Grid>
              <Grid item xs={12} container spacing={2}>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="Tipo di atto"
                    label="Tipo di atto*"
                    id="typeAct"
                    name="typeAct"
                    type="text"
                    inputProps={{
                      maxLength: '50',
                    }}
                    variant="outlined"
                    value={formStampCertificate.values.typeAct || ''}
                    disabled={disabled}
                    fullWidth
                    onChange={formStampCertificate.handleChange}
                    error={
                      formStampCertificate.touched.typeAct &&
                      Boolean(formStampCertificate.errors.typeAct)
                    }
                    helperText={formStampCertificate.errors.typeAct}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="Elemento di stampa"
                    label="Elemento di stampa*"
                    id="printElement"
                    name="printElement"
                    type="text"
                    inputProps={{
                      maxLength: '50',
                    }}
                    variant="outlined"
                    value={formStampCertificate.values.printElement || ''}
                    disabled={disabled}
                    fullWidth
                    onChange={formStampCertificate.handleChange}
                    error={
                      formStampCertificate.touched.printElement &&
                      Boolean(formStampCertificate.errors.printElement)
                    }
                    helperText={formStampCertificate.errors.printElement}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    aria-label="Modificatore"
                    label="Modificatore"
                    id="editor"
                    name="editor"
                    type="text"
                    inputProps={{
                      maxLength: '50',
                    }}
                    variant="outlined"
                    value={formStampCertificate.values.editor || ''}
                    disabled={disabled}
                    fullWidth
                    onChange={formStampCertificate.handleChange}
                    error={
                      formStampCertificate.touched.editor &&
                      Boolean(formStampCertificate.errors.editor)
                    }
                    helperText={formStampCertificate.errors.editor}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <PmiTextField
                  aria-label="Testo da stampare"
                  label="Testo da stampare*"
                  id="text"
                  name="text"
                  fullWidth
                  multiline
                  rows={5}
                  variant="outlined"
                  value={formStampCertificate.values.text || ''}
                  onChange={formStampCertificate.handleChange}
                  disabled={disabled}
                  error={
                    formStampCertificate.touched.text && Boolean(formStampCertificate.errors.text)
                  }
                  helperText={formStampCertificate.errors.text}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <PmiTextField
                  aria-label="Testo"
                  label="Testo *"
                  id="text"
                  name="text"
                  fullWidth
                  multiline
                  rows={5}
                  variant="outlined"
                  value={formStampCertificate.values.text || ''}
                  onChange={formStampCertificate.handleChange}
                  disabled={disabled}
                  error={
                    formStampCertificate.touched.text && Boolean(formStampCertificate.errors.text)
                  }
                  helperText={formStampCertificate.errors.text}
                />
              </Grid> */}
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              onCancel(formStampCertificate.values);
            }}
          >
            Annulla
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormStampCertificate.displayName = 'Form Print Formula component';

export default FormStampCertificate;
